// extracted by mini-css-extract-plugin
export default {"wapper":"SelectSingle_wapper__+hwXD","chipItem":"SelectSingle_chipItem__JKA3V","errorMsg":"SelectSingle_errorMsg__BI0mf"};